module.exports = __webpack_public_path__ + "static/media/toolsCog.d2c7c165.svg";